<script lang="ts" setup>
import { computed } from 'vue'

import { CricketSubParticipantStatId } from '@collector/sportsapi-client-legacy'
import { useEventSubParticipants } from '@mobile/views/Relation/useEventSubParticipants'

interface Props {
  subParticipantId: number
  batter?: boolean
  bowler?: boolean
}

const props = defineProps<Props>()

// composable
const { eventSubParticipants } = useEventSubParticipants()

// computed
const subParticipantStats = computed(() => {
  const subParticipant = eventSubParticipants.value.find(
    (sp) => sp.id === props.subParticipantId,
  )
  return subParticipant?.stats ?? []
})

// methods
const getStatValue = (
  statId: CricketSubParticipantStatId,
): number | string | null => {
  return (
    subParticipantStats.value.find((stat) => stat.id === statId)?.value ?? null
  )
}
</script>

<template>
  <div
    v-if="batter"
    class="flex gap-1"
  >
    <div>
      {{ getStatValue(CricketSubParticipantStatId.BatScore) || '---' }}
    </div>
    <div>
      ({{ getStatValue(CricketSubParticipantStatId.BallsFaced) || '---' }})
    </div>
  </div>

  <div
    v-if="bowler"
    class="flex gap-1"
  >
    <div>
      {{ getStatValue(CricketSubParticipantStatId.BowlerWkts) || '---' }}
    </div>
    <div>-</div>
    <div>
      {{ getStatValue(CricketSubParticipantStatId.RunsConceded) || '---' }}
    </div>
    <div>
      ({{ getStatValue(CricketSubParticipantStatId.NumberOfOvers) || '---' }}
    </div>
    <div>.</div>
    <div>
      {{ getStatValue(CricketSubParticipantStatId.BallsBowled) || '---' }})
    </div>
  </div>
</template>
